module.exports = __webpack_public_path__ + "img/backup-dashboard-icon.ff370f09.svg";